import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { emojiUrl, emojiMap, emojiList } from '../util';
import SvgIcon from '../../common/SvgIcon.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'emoji',
  emits: ['choose-emoji'],
  setup(__props, { emit }) {

const visible = ref(false);


const chooseEmoji = (itemName: string) => {
  const emojiInfo = itemName;
  closePopover();
  emit('choose-emoji', emojiInfo);
};

const outSide = (e: Event) => {
  const emojiPopover = (e.target as HTMLElement).closest('.emoji-popover');
  if (!emojiPopover) {
    closePopover();
  }
};
const togglePopover = () => {
  visible.value = !visible.value;
};
const closePopover = () => {
  visible.value = false;
};


return { __sfc: true,visible, emit, chooseEmoji, outSide, togglePopover, closePopover, emojiUrl, emojiMap, emojiList, SvgIcon }
}

})